export const BetsMessageType = {
  NEW: 'NEW',
  PARTIALLY_CASHED_OUT: 'PARTIALLY_CASHED_OUT',
  SETTLED: 'SETTLED',
  UPDATED: 'UPDATED',
};
